import id from "vue-cal/dist/i18n/id.cjs";

const CandidateModel = {
    data() {
        return {
            CandidateModel: {

                requestMagicLink: (payload) =>
                    this.$http.post(`/v3/auth/magic-link/request`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                login: data =>
                    this.$http.post('v2/candidate/login', data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                socialLogin: (authOrigin, data) =>
                    this.$http.post(`/v2/candidate/social-login`, data, {
                        params: {
                            provider: authOrigin
                        }
                    })
                        .then(r => r.data, e => Promise.reject(e.data)),

                register: data =>
                    this.$http.post('v2/candidate/register', data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                resendVerificationCode: params =>
                    this.$http.get('v2/candidate/resend-verification-code', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                getAbandonedJobApplication: (id) =>
                    this.$http.get(`/v3/abandoned-applications/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getApplicantsLastApplication: () =>
                    this.$http.get(`/v2/candidate/job-applications/most-recent`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                verifyAccount: data =>
                    this.$http.post('v2/candidate/verify-account', data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                resetPassword: (payload) =>
                    this.$http.post('v2/candidate/reset-password', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getCandidateProfile: candidateId =>
                    this.$http.get('v2/candidate/profile', {
                        params: {
                            candidate_id: candidateId
                        }
                    }).then(r => r.data, e => Promise.reject(e.data)),

                updateCandidateProfile: (payload) =>
                    this.$http.post('v2/candidate/profile/update', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getCandidateSkills: () =>
                    this.$http.get('v2/skills')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getCandidateInterests: () =>
                    this.$http.get('v2/interests')
                        .then(r => r.data, e => Promise.reject(e.data)),

                postResume: (data, headers) =>
                    this.$http.post('v2/candidate/profile/resume-to-history', data, headers)
                        .then(r => r.data, e => Promise.reject(e.data)),
                
                getResumeHistory: (candidateId= 0) => {
                    if ( !candidateId ) return;
                    
                    return this.$http.get(`v2/candidate/profile/resume-history${ candidateId ? '/'+candidateId  : ''}`)
                          .then(r => r.data, e => Promise.reject(e.data))
                },

                getCandidateInterviews: () =>
                    this.$http.get('/v2/candidate/profile/get-interviews')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getCandidateAssessment: (candidateId=0) =>
                    this.$http.get(`/v2/candidate/get-assessments${ candidateId ? '/'+candidateId  : ''}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getCandidateJobs: () =>
                    this.$http.get('/v2/candidate/job-applications')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getJobRecommendations: () =>
                    this.$http.get('/v2/candidate/recommendations')
                        .then(r => r.data, e => Promise.reject(e.data)),

                acceptOrDeclineRecommendation: (recommendation_id, data) =>
                    this.$http.post(`v2/candidate/recommendations/${recommendation_id }/update`, data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                deleteResume: (id) =>
                    this.$http.delete(`/v2/candidate/profile/resume-history/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                deleteAccount: (payload) =>
                    this.$http.delete('/v2/candidate/account', { data: payload })
                        .then(r => r.data, e => Promise.reject(e.data)),
            }

        }
    }
}

export default CandidateModel;
